export default __webpack_public_path__ + "static/media/logo-black.bc29876b.png";